"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ExpandIcon = _interopRequireDefault(require("./ExpandIcon"));

var _AccordionExtraCounter = _interopRequireDefault(require("./ExtraCounter/AccordionExtraCounter"));

var _utils = require("../../../../utils");

require("./AccordionHeader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function AccordionHeader(props) {
  var uId = props.uId,
      role = props.role,
      count = props.count,
      isActive = props.isActive,
      disabled = props.disabled,
      children = props.children,
      headerClass = props.headerClass,
      onClick = props.onClick;
  var classNameHeader = (0, _utils.getClassNames)('AccordionPanel-header', headerClass);

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter' || e.keyCode === 13 || e.keyCode === 32) {
      onClick();
    }

    if (isActive && (e.key === 'Escape' || e.keyCode === 27)) {
      onClick();
    }

    if (isActive && (e.key === 'ArrowUp' || e.keyCode === 38)) {
      onClick();
    }

    if (!isActive && (e.key === 'ArrowDown' || e.keyCode === 40)) {
      onClick();
    }
  };

  var extra = (0, _react.useMemo)(function () {
    return count && /*#__PURE__*/_react.default.createElement(_AccordionExtraCounter.default, {
      count: count
    });
  }, [count]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react.default.createElement("div", {
      role: role,
      tabIndex: disabled ? -1 : 0,
      className: classNameHeader,
      "aria-expanded": isActive,
      "aria-controls": uId,
      onClick: onClick,
      onKeyDown: handleKeyPress
    }, /*#__PURE__*/_react.default.createElement(_ExpandIcon.default, {
      isActive: isActive
    }), children, extra && /*#__PURE__*/_react.default.createElement("div", {
      className: "AccordionPanel-extra"
    }, extra))
  );
}

AccordionHeader.propTypes = {
  uId: _propTypes.default.string.isRequired,
  role: _propTypes.default.number,
  count: _propTypes.default.number,
  isActive: _propTypes.default.number,
  disabled: _propTypes.default.number,
  children: _propTypes.default.node,
  headerClass: _propTypes.default.number,
  onClick: _propTypes.default.func
};
AccordionHeader.defaultProps = {
  role: 'button',
  count: null,
  isActive: false,
  disabled: false,
  children: null,
  headerClass: null,
  onClick: function onClick() {}
};
var _default = AccordionHeader;
exports.default = _default;